<template>
  <div>
    <v-form v-model="form_valido" lazy-validation ref="formulario">
      <z-dialogo ref="dialogo" largura="700px" titulo="Loja" dividers persistent
        @abrir="$refs.formulario.resetValidation()">
        <template v-slot:conteudo>
          <v-row dense>
            <v-col cols="12" sm="12">
              <v-text-field 
                v-model="loja.nome" 
                filled 
                dense 
                ref="nome" 
                label="Nome"
                maxlength="40"
                counter="40"
                @keyup="gerarAbreviacao"
                :rules="[regras.campoObrigatorio]"
              ></v-text-field>
            </v-col>
            <v-col cols="4" sm="4">
              <z-text-field 
                v-model="loja.abreviacao" 
                upper 
                filled 
                dense 
                ref="abreviacao" 
                label="Abreviação" 
                maxlength="3" :rules="[regras.campoObrigatorio]"
              ></z-text-field>
            </v-col>
            <v-col cols="4" sm="4">
              <v-text-field 
                v-model="loja.cor_primaria" 
                filled 
                dense 
                ref="cor" 
                label="Cor da Loja"
                readonly
              >
                <template v-slot:append>
                  <v-icon :color="loja.cor_primaria" @click="abrirEscolherCor">mdi-palette</v-icon>
                </template>
              </v-text-field>
            </v-col>
          </v-row>
        </template>

        <template v-slot:actions_left v-if="loja.padrao != 1">
          <v-switch class="my-0" color="primary" label="Ativa" v-model="loja.ativa" hide-details></v-switch>
        </template>
        <template v-slot:actions_right>
          <v-btn text @click="fechar" :disabled="salvando">Cancelar</v-btn>
          <v-btn color="primary" depressed ref="btnConfirmar" :loading="salvando" :disabled="!form_valido"
            @click="confirmar">Confirmar</v-btn>
        </template>
      </z-dialogo>
    </v-form>
    <escolher-cor ref="dialogoEscolherCor" @input="atualizarCor"></escolher-cor>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from "vuex";
import * as regras from "@/app/helpers/validacoes";
import EscolherCor from "./EscolherCor.vue";

export default {
  name: "LojasForm",

  components: { EscolherCor },

  data() {
    return {
      excluindo: false,
      salvando: false,
      form_valido: true,
      regras: { ...regras },
    };
  },

  computed: {
    ...mapState({
      loading: (state) => state.loading,
      loja_atual: (state) => state.lojas.loja_atual,
    }),

    ...mapState("lojas", ["loja", 'lojas']),

    lojas_count() {
      return this.lojas.length;
    },
  },

  methods: {
    ...mapActions("lojas", [
      "listar",
      "excluir",
      "abrir",
      "atualizar",
      "salvar",
    ]),

    abrir() {
      this.$refs.dialogo.abrir();
    },

    fechar() {
      this.$refs.formulario.resetValidation();
      this.$refs.dialogo.fechar();
    },

    async confirmar() {
      if (!this.$refs.formulario.validate()) {
        return false;
      }

      try {
        this.salvando = true;

        if (this.loja.id) {
          await this.atualizar(this.loja);
          this.$eventbus.notificar("Loja atualizada.");
        } else {
          await this.salvar(this.loja);
          this.$eventbus.notificar("Loja cadastrada com sucesso.");
        }

        this.setTemaSeLojaAtual();
        this.fechar();
      } catch (error) {
        this.$eventbus.erroSistema(
          "Não foi possível salvar esta loja. Verifique os dados preenchidos."
        );
      } finally {
        this.salvando = false;
      }
    },

    abrirEscolherCor() {
      this.$refs.dialogoEscolherCor.abrir();
    },

    atualizarCor(cor) {
      this.loja.cor_primaria = cor;
    },

    setTemaSeLojaAtual() {
      let isLojaAtual = this.loja.id == this.loja_atual.id;
      if (isLojaAtual) {
        this.$storage.set("loja", this.loja);
        this.$store.commit("lojas/SET_LOJA_ATUAL", this.loja);
        this.$vuetify.theme.themes.light.primary = this.loja.cor_primaria;
      }
    },

    gerarAbreviacao() {
      let abreviacao = "";
      if (this.loja.nome.includes(" ") && this.loja.nome.split(" ").length > 1) {
        abreviacao = this.loja.nome
          .split(" ")
          .map((palavra) => palavra[0])
          .join("")
          .toUpperCase();
      } else {
        abreviacao = this.loja.nome.slice(0, 2).toUpperCase();
      }
      this.loja.abreviacao = abreviacao.slice(0, 3);
    },
  },
};
</script>

<style scoped></style>
